import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab";
import {actionSaveService, actionServiceFetch} from "../../store/services/actions";
import {actionActiveTabTitle} from '../../store/tabs/actions';
import {Tab} from '../Tab';
import {Validator} from '../../core/Validator';
import {ServiceDescriptor, unitTypes} from '../../models/Service';
import {Utility} from '../../core/Utility';
import {Category} from "../../models/Category";
import {actionCategoryFetchAll} from "../../store/categories";
import {PopupDialog} from '../../core/components/PopupDialog';
import {AppCookies} from "../../core/Cookies";
import {t} from "../../core/localization";
import ServicesService from "../../services/ServicesService";

export interface ServiceTabProps extends BaseTabProps{
	tab: Tab
	categories: Category[]
}

export interface ServiceTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		categories: state.categories.list
	};
}

class ServiceTab extends BaseTab<ServiceTabProps, ServiceTabState> {

	constructor(props: ServiceTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
    }

	componentDidMount() {
		actionCategoryFetchAll()
		if (this.props.item.id) actionServiceFetch(this.props.item)
	}

	componentWillMount() {

		if (this.props.item.id)
			actionServiceFetch(this.props.item)

		// let service: Service = new Service();

		// if(this.props.item){
		// 	service = this.props.item as Service
		// }

		// let tabState = this.props.state
		// if (!tabState['item']) tabState['item'] = {...service}
		// actionSetTabState(tabState)
	}

	componentWillReceiveProps(nextProps: ServiceTabProps) {

		// let tabState = this.props.state
		// if (tabState['item']) {
		// 	if(nextProps.selectedService && tabState['item'].id !== nextProps.selectedService.id){
		// 		tabState['item'].id = nextProps.selectedService.id
		// 		actionSetTabState(tabState)
		// 	}
		// }
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderControls()}
				{this.renderPopupDialog()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		return <form className='ev-form' noValidate autoComplete="on">
				<TextField
					label={t.Title}
					value={Utility.formatString(this.getItemFromTabState('title'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'title')}}
					margin="normal"
					fullWidth
					required={true}
					error={Validator.displayFormErrors(this.state.validation.fields, 'title').show}
					helperText={Validator.displayFormErrors(this.state.validation.fields, 'title').message}
				/>
				<TextField
					label={t.Description}
					value={Utility.formatString(this.getItemFromTabState('description'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'description')}}
					margin="normal"
					fullWidth
				/>
				<TextField
					label={t.Price}
					value={Utility.formatString(this.getItemFromTabState('price'))}
					onChange={(e) => {this.handleItemTextInputChange(e, 'price')}}
					margin="normal"
					fullWidth
					required={true}
					error={Validator.displayFormErrors(this.state.validation.fields, 'price').show}
					helperText={Validator.displayFormErrors(this.state.validation.fields, 'price').message}
				/>
				{/*<TextField*/}
				{/*	label="Unit"*/}
				{/*	value={Utility.formatString(this.getItemFromTabState('unitName'))}*/}
				{/*	onChange={(e) => {this.handleItemTextInputChange(e, 'unitName')}}*/}
				{/*	margin="normal"*/}
				{/*	fullWidth*/}
				{/*	//error={!Validator.validate(this.getItemFromTabState('price'), ServiceDescriptor.price.validation)}*/}
				{/*/>*/}
				<FormControl required style={{width: '100%', marginTop:'15px'}} >
					<InputLabel htmlFor="age-required">{t.PriceUnit}</InputLabel>
					<Select
						value={Utility.formatString(this.getItemFromTabState('unitName'))}
						onChange={(e) => {this.handleItemSelectChange(e, 'unitName')}}
						name="unitName"
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'unitName').show}
						style={{width: '100%'}}>
						{this.renderUnitTypeOptions()}
					</Select>
					<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'unitName').message}</FormHelperText>
				</FormControl>
				{/*<TextField*/}
				{/*	label="Invoice type"*/}
				{/*	value={Utility.formatString(this.getItemFromTabState('invoicingType'))}*/}
				{/*	onChange={(e) => {this.handleItemTextInputChange(e, 'invoicingType')}}*/}
				{/*	margin="normal"*/}
				{/*	fullWidth*/}
				{/*	//error={!Validator.validate(this.getItemFromTabState('price'), ServiceDescriptor.price.validation)}*/}
				{/*/>*/}
				{/*<TextField*/}
				{/*	label="Invoice period"*/}
				{/*	value={Utility.formatString(this.getItemFromTabState('invoicingPeriod'))}*/}
				{/*	onChange={(e) => {this.handleItemTextInputChange(e, 'invoicingPeriod')}}*/}
				{/*	margin="normal"*/}
				{/*	fullWidth*/}
				{/*	//error={!Validator.validate(this.getItemFromTabState('price'), ServiceDescriptor.price.validation)}*/}
				{/*/>*/}
				<FormControl required style={{width: '100%', marginTop:'20px'}} >
					<InputLabel htmlFor="age-required">{t.Category}</InputLabel>
					<Select
						value={Utility.formatString(this.getItemFromTabState('categoryId'))}
						onChange={(e) => {this.handleItemSelectChange(e, 'categoryId')}}
						name="categoryId"
						required={true}
						error={Validator.displayFormErrors(this.state.validation.fields, 'categoryId').show}
						style={{width: '100%'}}>
						{this.props.categories.map((component, key) => (
							<MenuItem key={key} value={component.id}>{component.title}</MenuItem>
						))}
					</Select>
					<FormHelperText style={{color: '#ed1a3a'}}>{Validator.displayFormErrors(this.state.validation.fields, 'categoryId').message}</FormHelperText>
				</FormControl>
		</form>;
	}

	renderUnitTypeOptions () {
		let items: any[] = []

		Object.values(unitTypes).forEach((value) => {
			items.push(<MenuItem key={value} value={value}>{ServicesService.unitForInvoice(value)}</MenuItem>)
		});
		return items
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {

		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, ServiceDescriptor)

		if (validation.valid) {
			actionSaveService(itemToSave)
			actionActiveTabTitle(t.Service + ': ' + this.getItemFromTabState('title'))
		}

		this.setState({ ...this.state, validation: validation });
	}

}

export default connect(mapStateToProps)(ServiceTab);
